import React from 'react'
import styled from 'react-emotion'

import { colours } from '../../theme'

const Wrapper = styled('div')`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin: 2rem 0;
`

const Number = styled('div')`
	color: ${colours.primary};
	font-size: 6rem;
	margin-right: 2rem;
	opacity: 0.6;
`

const Text = styled('div')`
	font-size: 1.4rem;
	font-weight: 700;
`

const Page = ({ text, page }) => (
	<Wrapper>
		<Number>{page}</Number>
		<Text>{text}</Text>
	</Wrapper>
)

export default Page
